import React, { useState, useEffect } from 'react'
import { Card, CardHeader, CardContent, Typography, makeStyles, Button } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import EditNoteDialog from '../Dialogs/Visit/EditNoteDialog'
import { gray, purple } from '../../utils/colors'

const useStyles = makeStyles((theme) => ({
	card: {
		backgroundColor: gray[100],
		boxShadow: 'none',
		border: `1px solid ${gray[400]}`,
		borderWidth: 1
	},
	header: {
		padding: '13px 24px',
		'& .MuiCardHeader-action': {
			margin: 0
		},
		'& .MuiCardHeader-title': {
			textTransform: 'none'
		}
	},
	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest
		}),
		padding: 0
	},
	expandOpen: {
		transform: 'rotate(180deg)'
	}
}))

const ClientNotes = ({ notes = '' }) => {
	const theme = useTheme()
	const classes = useStyles(theme)

	return (
		<Card className={classes.card}>
			<CardHeader className={classes.header} title="Client Notes" />
			<CardContent>{notes > '' ? notes : 'No notes.'}</CardContent>
		</Card>
	)
}

export default ClientNotes
